import { DM_DuyetChiTiet } from './../kho-de-nghi-xuat-kho-model/kho-de-nghi-xuat-kho.model';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable,  BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../../../environments/environment';
import { HttpUtilsService } from '../../../../../../core/_base/crud/utils/http-utils.service';
import { QueryParamsModel, QueryResultsModel } from '../../../../../../core/_base/crud';
import { KhoDeNghiXuatKho, KhoDeNghiXuatKhoChiTiet} from '../kho-de-nghi-xuat-kho-model/kho-de-nghi-xuat-kho.model';
const API_ROOT_URL = environment.ApiRoot + '/denghixuatkho';
const API_ROOT_URL_SPDHB = environment.ApiRoot + '/kddathang';

@Injectable()
export class KhoDeNghiXuatKhoService {
	lastFilter$: BehaviorSubject<QueryParamsModel> = new BehaviorSubject(new QueryParamsModel({}, 'asc', '', 0, 10));
	lastFilterDN$: BehaviorSubject<QueryParamsModel> = new BehaviorSubject(new QueryParamsModel({}, 'asc', '', 0, 10));
	lastFilterDSExcel$: BehaviorSubject<any[]> = new BehaviorSubject([]);
	lastFilterInfoExcel$: BehaviorSubject<any> = new BehaviorSubject(undefined);
	lastFileUpload$: BehaviorSubject<{}> = new BehaviorSubject({});
	data_import:  BehaviorSubject<any[]> = new BehaviorSubject([]);
	ReadOnlyControl: boolean;
	constructor(private http: HttpClient,
	private httpUtils: HttpUtilsService) { }

	getData(queryParams: QueryParamsModel): Observable<QueryResultsModel>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		return this.http.get<any>(API_ROOT_URL + '/List_PhieuDeNghiXuatKho', {
			headers: httpHeaders,
			params: httpParams
		});
	}

	getDataSLTon(queryParams: QueryParamsModel): Observable<QueryResultsModel>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		return this.http.get<any>(API_ROOT_URL + '/List_ChiTietSoLuongTon', {
			headers: httpHeaders,
			params: httpParams
		});
	}

	insert(item: KhoDeNghiXuatKho): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders(false);
		return this.http.post<any>(API_ROOT_URL+'/TaoPhieuDeNghiXuatKho', item, { headers: httpHeaders });
	}

	edit(item: KhoDeNghiXuatKho): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<KhoDeNghiXuatKho>(API_ROOT_URL+'/SuaPhieuDeNghiXuatKho', item, { headers: httpHeaders });
	}

	detail(item: number): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<KhoDeNghiXuatKho>(API_ROOT_URL+`/Detail_PhieuDeNghiXuatKho?IdDn=${item}`, { headers: httpHeaders });
	}

	delete(item: number): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<KhoDeNghiXuatKho>(API_ROOT_URL+`/Delete_PhieuDeNghiXuatKho?id=${item}`, { headers: httpHeaders });
	}

	changeStatus(item: any): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<KhoDeNghiXuatKho>(API_ROOT_URL+'/ChangeStatus', item, { headers: httpHeaders });
	}

	accept(item: KhoDeNghiXuatKho): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<KhoDeNghiXuatKho>(API_ROOT_URL+`/Duyet_PhieuDeNghiXuatKho?id=${item.IdDn}&&LyDo=${item.Lydokhongduyet}`, { headers: httpHeaders });
	}

	reject(item: KhoDeNghiXuatKho): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<KhoDeNghiXuatKho>(API_ROOT_URL+'/KhongDuyet_PhieuDeNghiXuatKho', item, { headers: httpHeaders });
	}

	remove(item: number): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<KhoDeNghiXuatKho>(API_ROOT_URL+`/Remove_PhieuDeNghiXuatKho?id=${item}`, { headers: httpHeaders });
	}

	uploadFileImport(data): Observable<any> {
		const url = API_ROOT_URL + '/ImporttFile';
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(url, data, { headers: httpHeaders });
	}
	// downloadTemplate(): string {
	// 	return API_ROOT_URL + `/DownloadFileExample`;
	// }

	downloadTemplate(LoaiPhieu: number): Observable<Blob>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const params = new HttpParams().set('LoaiPhieu', LoaiPhieu.toString());
		return this.http.get<Blob>(API_ROOT_URL + '/DownloadFileExample', {
		  headers: httpHeaders,
		  params: params,
		  responseType: 'blob' as 'json'
		});
	  }

	liteSPDHB(): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<KhoDeNghiXuatKho>(API_ROOT_URL_SPDHB+`/DatHang_Lite`, { headers: httpHeaders });
	}

	luuKetQuaDuyet(item: DM_DuyetChiTiet): Observable<any> {
		const url = API_ROOT_URL + '/LuuKetQuaDuyet';
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(url, item, { headers: httpHeaders });
	}

	xacNhanNhanHang(item: DM_DuyetChiTiet): Observable<any> {
		const url = API_ROOT_URL + '/XacNhanNhanHang';
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(url, item, { headers: httpHeaders });
	}
}
